<template>
  <!-- 回收站列表 -->
  <div class="recycle-page">
    <div
      style="
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 45px;
      "
    >
      <div style="display: flex; align-items: center">
        <span
          style="
            display: block;
            width: 70px;
            font-size: 14px;
            color: #2f4257;
            margin-bottom: 3px;
            white-space: nowrap;
            margin-right: 10px;
          "
          >问卷名称:</span
        >
        <el-input
          type="text"
          v-model="queryParams.questionnaireName"
          placeholder="单行输入"
        ></el-input>
      </div>
      <div>
        <el-button @click="getListReset">重置</el-button>
        <el-button type="primary" @click="getDataOne">查询</el-button>
      </div>
    </div>
    <div class="content" style="margin-top: 15px">
      <el-table
        :data="tableData"
        style="width: 100%"
        header-align="center"
        :header-cell-style="{ background: '#F6F7FA' }"
        :cell-style="{ background: '#ffffff' }"
        :border="true"
		:empty-text="loading ? '加载中' : '暂无数据'"
      >
        <el-table-column
          prop="questionnaireName"
          label="问卷名称"
          width="auto"
          align="left"
        >
        </el-table-column>
        <!-- <el-table-column prop="releaseStatus" label="发布状态" width="auto" align="center">
            <template slot-scope="scope">
              {{ scope.row.releaseStatus == 0 ? '草稿' : scope.row.releaseStatus == 1 ? '已发布' : '未发布' }}
            </template>
</el-table-column> -->
        <el-table-column
          prop="questionNum"
          label="题目数量"
          width="auto"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="browseNum"
          label="浏览数量"
          width="auto"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="问卷创建时间"
          width="auto"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column label="状态" width="auto" align="center">
            <template slot-scope="scope">
              {{ scope.row.status == 0 ? '正常' : '停用' }}
            </template>
          </el-table-column> -->
        <el-table-column label="操作" width="auto" align="center">
          <template slot-scope="scope">
            <!--  -->
            <el-button
              @click.native.prevent="restoreClick(tableData[scope.$index])"
              type="text"
            >
              恢复
            </el-button>
            <el-button
              @click.native.prevent="delClick(tableData[scope.$index])"
              type="text"
            >
              彻底删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="queryParams.pageSize"
          :current-page="currentPage"
          :total="total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import { templateList, infoFreeze, convertTemplate } from "@/api/userManagement/index";
import { recycleBinList, setRecycleQuestionnaire } from "@/api/index.js";
export default {
  dicts: ["sys_job_status"],
  data() {
    return {
      tableData: [],
      clickItem: {},
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        questionnaireName: "",
        releaseStatus: "",
      },
      dateRange: [],

      total: 0,
      currentPage: 1,
      isAddShow: false,
      islookShow: false,
      input: "",
      dataOne: "",
      peopleID: "",
      stateDic: [
        {
          label: "所有",
          value: "",
        },
        {
          label: "已发布",
          value: "1",
        },
        {
          label: "未发布",
          value: "0",
        },
      ],
	  loading: false
    };
  },
  created() {
    window.addEventListener("keyup", this.enterSearchOrder);
  },
  mounted() {
    this.queryParams.userKey = this.$route.query.peopleID;
    console.log(this.peopleID, "this.peopleID");
    this.getData();
  },
  methods: {
    // 重置
    getListReset() {
      // this.dateRange = []
      this.queryParams.releaseStatus = null;
      this.queryParams.questionnaireName = null;
      this.queryParams.userKey = null;
      this.currentPage = 1;
      this.queryParams.pageNum = 1;

      this.getData();
    },
    // 回车事件
    enterSearchOrder: function (e) {
      if (e.keyCode === 13) {
        this.queryParams.pageNum = 1;
        this.getData(); //这里的操作，是回车之后想要进行的操作，尽量全部写在一个方法里面
      }
    },
    getDataOne() {
      this.queryParams.pageNum = 1;
      this.currentPage = 1;
      this.getData();
    },
    // 查询数据
    getData() {
		this.loading = true
      recycleBinList({
        releaseStatus: this.queryParams.releaseStatus,
        pageNum: this.currentPage,
        questionnaireName: this.queryParams.questionnaireName,
      }).then((response) => {
        this.tableData = response.rows;
        this.total = response.total;
      }).catch((err) => {
		  console.log("err", err);
		})
		.finally(() => {
		  this.loading = false;
		});
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryParams.pageNum = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getData();
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.queryParams.pageNum = page;
      // 这里可以添加获取新页数据的逻辑
      console.log("切换到页码:", page);
      this.getData();
    },
    // 查看详情
    shareClick(item) {
      this.clickItem = item;
      console.log(this.clickItem, "this.clickItem");
      this.dialogVisible = true;
    },
    // 恢复问卷
    restoreClick(item) {
      this.$confirm("是否恢复该问卷？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //delFlag（0代表恢复  2代表删除）
          setRecycleQuestionnaire({ uuid: item.uuid, delFlag: 0 }).then(
            (response) => {
              this.$message.closeAll();
              this.$message({
                message: "恢复成功",
                type: "success",
              });
              this.queryParams.pageNum = 1;
              this.getData();
            }
          );
        })
        .catch(() => {});
    },
    //   彻底删除
    delClick(item) {
      //delFlag（0代表恢复  2代表删除）

      this.$confirm("是否彻底删除该问卷？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //delFlag（0代表恢复  2代表删除）
          setRecycleQuestionnaire({ uuid: item.uuid, delFlag: 2 }).then(
            (response) => {
              this.$message.closeAll();
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.queryParams.pageNum = 1;
              this.getData();
            }
          );
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.recycle-page {
  width: 100%;
  height: 100%;
  padding: 15px;
  background: #ffffff;
  border-radius: 6px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 240px;
}

.huise {
  width: 100%;
  height: 100vh;
  background-color: rgba(000, 000, 000, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.tanchuang {
  min-width: 397px;
  padding: 0 0 20px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  position: relative;

  .el-icon-close {
    position: absolute;
    right: 13px;
    top: 18px;
    cursor: pointer;
  }

  .top1 {
    width: 100%;
    height: 50px;
    background-color: #eaeaea;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 17px;
  }

  .content1 {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 40px;
    box-sizing: border-box;

    .allview {
      display: flex;
      align-items: flex-start;
      margin-bottom: 17px;

      span {
        display: block;
        width: 95px;
        font-size: 16px;
        color: #6a6a6a;
        text-align: end;
      }

      .el-input {
        width: 196px;
        height: 30px;
      }

      div {
        font-size: 16px;
        color: #6a6a6a;
      }
    }
  }

  .el-button {
    background-color: #086ed9;
    color: #ffffff;
    cursor: pointer;
  }
}

.bigcontent {
  width: 100%;
  min-width: 1000px;
  padding: 10px;
  box-sizing: border-box;
  /* margin-top: 35px; */
  padding: 0;

  .top {
    /* // width: 100%; */
    background-color: #ffffff;
    padding: 18px 20px 12px 20px;
    margin: 0;

    .topfirst {
      display: flex;
      align-items: center;

      .inpstyle {
        display: flex;
        align-items: center;
        margin-right: 30px;

        span {
          display: block;
          width: 70px;
          font-size: 14px;
          color: #2f4257;
          margin-bottom: 3px;
        }

        .el-input {
          width: 240px;
          border: 1px solid #e6e6e6;

          .el-input__inner {
            border: none;
          }
        }

        .el-select {
          width: 240px;
        }
      }
    }
  }

  .content {
    /* padding: 13px; */
    box-sizing: border-box;
    background-color: #ffffff;
    overflow: hidden;
  }
}

.betweenFlx {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.columnFlx {
  display: flex;
  flex-direction: column;
}

.flexStart {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.el-pagination {
  float: right;
}

.el-table .el-table__header-wrapper th,
.el-table .el-table__fixed-header-wrapper th {
  background-color: #edf2fa;
}

.el-drawer__container {
  position: relative;
  top: 200px;
  right: 40%;
}

/* // 弹窗样式 */
.bigcontent1 {
  width: 100%;
  height: 420px;
  padding: 10px;
  box-sizing: border-box;

  .alldiv {
    background-color: #ffffff;
    padding: 18px;
    box-sizing: border-box;
    height: 420px;
    overflow: auto;
  }

  .biao {
    width: 100%;
    display: flex;
    align-items: center;

    span {
      display: block;
      width: 5px;
      height: 14px;
      background-color: #5174f0;
      border-radius: 2px;
      margin-right: 10px;
    }

    h2 {
      font-size: 16px;
      color: #0f0f0f;
    }
  }

  .allinp {
    padding: 10px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .inpstyle {
      min-width: 240px;
      display: flex;
      flex-direction: column;
      margin-right: 30px;

      span {
        font-size: 16px;
        color: #2f4257;
        margin-bottom: 3px;
      }

      el-input {
        width: 100%;
      }
    }

    .selBiao {
      font-size: 16px;
      margin-right: 10px;
      font-weight: 600;
    }

    .selStyle {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      span {
        font-size: 14px;
        color: #0f0f0f;
        margin-right: 10px;
      }
    }
  }

  .message {
    span {
      font-size: 14px;
      color: #5174f0;
      margin-bottom: 12px;
      cursor: pointer;
    }
  }

  .footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
}

.left-panel {
  /* // flex: 1; */
  background: #007aff;
  color: white;
  border-radius: 10px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  width: 120px;
  margin-bottom: 15px;
}

.beta {
  background: yellow;
  color: black;
  padding: 5px 10px;
  border-radius: 3px;
  margin-bottom: 20px;
}

.title {
  font-size: 36px;
  margin-bottom: 30px;
}

.card {
  background: white;
  color: #007aff;
  padding: 25px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 20px;
}

.card-title {
  font-size: 24px;
  margin-bottom: 15px;
}

.qr-code {
  width: 180px;
}

.footer {
  display: flex;
  align-items: center;
  margin-top: auto;
}

.mini-logo {
  width: 40px;
  margin-right: 10px;
}

.right-panel {
  flex: 1;
  padding-left: 40px;
}

.info-box,
.link-box {
  margin-bottom: 30px;
}

.info-title,
.link-title {
  color: #007aff;
  border-bottom: 2px solid #007aff;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.info-item {
  margin: 8px 0;
}

.link-input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn-group {
  display: flex;
  gap: 15px;
  margin-top: 10px;
}

.btn {
  background: #007aff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.close-btn {
  background: #007aff;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 4px;
  font-size: 16px;
}

.header {
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;

  p {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  i {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RecyclePage/index.vue